import React, { useReducer, useMemo, createContext, useEffect, ReactNode } from "react";
import {
  callApi,
  isEmpty,
  deleteAutoLogin,
  openCommonAlert,
  deepCopyArray,
} from "bodycodi/cmap/app/js/common.js";
import Alert from "bodycodi/cmap/app/components/common/alert";
import Toast, { ToastFull } from "bodycodi/cmap/app/components/common/toast";
import Loading from "bodycodi/cmap/app/components/common/loading";

const initialState = {
  profileImg: "",
  confirmTermsPop: false,
  selectTimePop: false,
  selectTimeEditPop: false,
  rollingDateSelectPop: false,
  rollingYearSelectPop: false,
  rsrvCancleConfirmMultiPop: false,
  rsrvCancleConfirmOnePop: false,
  classAbsentConfirmOnePop: false,
  classScheduleConfirmOnePop: false,
  cofirmConditionOtUpd: false,
  cofirmConditionEtUpd: false,
  cofirmConditionCsUpd: false,
  chooseTimePickerUpdPop: false,
  otSelectPop: false,
  etSelectPop: false,
  csSelectPop: false,
  cofirmConditionEt: false,
  toast1: false,
  centerMngtIndexPop: false,
  centerMngtInfoPop: false,
  homePartnerListRefresh: 0,
  imageEditerUpdPop: false,
  comunityUpdPop: false,
  comunityConfirmPop: false,
  findPasswordCompletePop: false,
  findEmailCompletePop: false,
  findEmailPop: false,
  findPasswordPop: false,
  changePasswordPop1: false,
  centerListPop: false,
  alramPop: false,
  addSchedulePass: {},
  addScheduleSeqMember: {},
  addScheduleCenter: {},
  addScheduleType: "",
  addScheduleMember: 0,
  addScheduleStep: 1,
  changeNamePop: false,
  changePasswordPop: false,
  accountMngtPop: false,
  removeAccountPop: false,
  termsAndPolicyPop: false,
  serviceDetailPop: false,
  privacyDetailPop: false,
  privacyAgreePop: false,
  marketingDetailPop: false,
  cancleYn: false,
  redYn: false,
  redButtonLabel: "",
  greenButtonLabel: "",
  centerProfileUpdPop: false,
  loading: false,
  centerPropfilePop: false,
  centerMngtPop: false,
  imgPickerDrawerPop: false,
  scheduleDtlInfoPop: false,
  passCardInfoPop: false,
  passCardInfoType: "",
  commentUpdPop: false,
  commentConfirmPop: false,
  comunityDtlPop: false,
  comunityFoodDtlPop: false,
  goToCommentSection: false,
  myPagePop: false,
  programManagementPop: false,
  programManagementDetailPop: false,
  sellerProfilePop: false,
  salaryStatementPop: false,
  salaryDetailPop: false,
  eachSalaryDetailPop: false,
  contractDetailPop: false,
  salaryAgreePop: false,
  salaryObjectionPop: false,
  cofirmConditionCs: false,
  chooseTimePickerPop: false,
  chooseMemberPop: false,
  addComunityEditor: false,
  chooseMemberPassComunityPop: false,
  addComunityPop: false,
  addComunitySeqmember: "",
  comunityMemberList: [],
  comunityMemberListPop: false,
  showCommunityMemberList: [],
  cofirmConditionApoointment: false,
  chooseAppointmentTimePop: false,
  classAttendantCntPop: false,
  classScheduleResultAbsentPop: false,
  classAbsentConfirmPop: false,
  classScheduleResultPop: false,
  classScheduleBtnPop: false,
  classScheduleConfirmPop: false,
  apScheduleReConfirmPop: false,
  chooseMemberPassPop: false,
  chooseCenterStepPop: false,
  chooseDate: false,
  chooseMember: false,
  chooseServiceTypePop: false,
  notificationPop: false,
  apAbsentConfirmPop: false,
  rsrvCancleConfirmPop: false,
  apScheduleConfirmPop: false,
  apScheduleBtnPop: false,
  etcScheduleBtnPop: false,
  etcScheduleConfirmPop: false,
  etcAbsentConfirmPop: false,
  etcCancelConfirmPop: false,
  scheduleDtlPop: false,
  messagePop: false,
  memberDtlPop: false,
  memberSearchPop: false,
  requestAppPaymentPop: false,
  requestAppPaymentConfirmPop: false,
  chooseCenterPop1: false,
  chooseCenterPop: false,
  editEtcCalendarPop: false,
  editEtcTimePickerPop: false,
  toast: false,
  toastText: "",
  ternServicePop: false,
  joinPop: false,
  alert: false,
  header: "",
  body: "",
  fromMngt: false,
  isShowBottom: true,
  memoEditPop: false,
  cancelAlert: () => ({}),
  closeAlert: () => ({}),
  comunityFoodDetail: {},
};

export const DispatchContext = createContext<any | null>({ dispatch: () => ({}) });

export const StateContext = createContext<any | null>({ state: {} });

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case "POP_UP_OPEN":
      const key = Object.keys(action.open)[0];
      clickBack(action.id, action.open[key], key);
      return {
        ...state,
        ...action.open,
      };
    case "CLOSE_ALL_POP":
      window.dispatchEvent(new CustomEvent("closeAllPop", { detail: {} }));
      return {
        ...state,
      };
    case "ALERT_SETTING":
      return {
        ...state,
        ...action.data,
      };
    case "UPDATE":
      return {
        ...state,
        ...action.data,
      };
    case "UPDATE_ADDSCHEDULE":
      return {
        ...state,
        ...action.data,
        addScheduleMember: state.addScheduleMember + 1,
      };
    case "UPDATE_HOME_PARTNER_LIST_REFRESH":
      return {
        ...state,
        homePartnerListRefresh: state.homePartnerListRefresh + 1,
      };
    case "LOADING_START":
      return {
        ...state,
        loading: true,
      };
    case "LOADING_END":
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

declare global {
  interface Window {
    popHis: Array<any>;
    tui: any;
    editor: any;
  }
}

window.popHis = [];

const clickBack = (id: string, open: boolean, name: string) => {
  if (open) {
    window.popHis.push({ id: id, name: name });
  } else {
    window.popHis.pop();
  }
};

function Context({ children }: { children: ReactNode }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const stateValue = useMemo(() => ({ state: state }), [state]);
  const dispatchValue = useMemo(() => ({ dispatch: dispatch }), [dispatch]);

  useEffect(() => {
    window.addEventListener("alert", alertEvent);
    window.addEventListener("callApi", callApiEvent);
    window.addEventListener("expireAutoLogin", expireAutoLogin);
    window.addEventListener("closeAllPop", closeAllPop);
    window.addEventListener("loading", controlLoading, false);
    return () => {
      window.removeEventListener("loading", controlLoading, false);
      window.removeEventListener("callApi", callApiEvent);
      window.removeEventListener("expireAutoLogin", expireAutoLogin);
      window.removeEventListener("closeAllPop", closeAllPop);
    };
  }, []);

  const closeAllPop = () => {
    const copy = deepCopyArray(window.popHis);
    for (let i = 0; i < copy.length; i++) {
      const type = copy[i];
      const data: any = {};
      const data1: any = {};
      data["type"] = "POP_UP_OPEN";
      data["id"] = type.id;
      data1[type.name] = false;
      data["open"] = data1;
      dispatch({ ...data });
    }
    return state;
  };

  const setAlert = (open: boolean) => {
    dispatch({ type: "ALERT_SETTING", data: { alert: open } });
  };

  const alertEvent = (e: any) => {
    const header = e.detail.header;
    const body = e.detail.body;
    const cancelAlert = e.detail.cancelAlert;
    const closeAlert = e.detail.closeAlert;
    dispatch({
      type: "ALERT_SETTING",
      data: {
        header: header,
        redYn: false,
        cancleYn: false,
        body: body,
        cancelAlert: cancelAlert,
        closeAlert: closeAlert,
        alert: true,
      },
    });
  };

  const expireAutoLogin = (e: any) => {
    openCommonAlert({
      header: "로그인",
      body: "자동로그인 기간이 만료되었습니다. 다시 로그인 해주세요.",
      closeAlert: () => {
        deleteAutoLogin();
      },
    });
  };

  const callApiEvent = (e: any) => {
    callApi(e.detail.url, { ...e.detail.data }, e.detail.type).then((res) => {
      if (!isEmpty(e.detail.function)) {
        e.detail.function(res);
      }
    });
  };

  const setLoading = (open: boolean) => {
    if (open) {
      dispatch({ type: "LOADING_START" });
    } else {
      dispatch({ type: "LOADING_END" });
    }
  };

  const controlLoading = (e: any) => {
    setLoading(e.detail.loading);
  };

  return (
    <DispatchContext.Provider value={dispatchValue}>
      <StateContext.Provider value={stateValue}>
        {children}
        <Alert
          open={state.alert}
          setOpen={setAlert}
          header={state.header}
          body={state.body}
          cancelAlert={state.cancelAlert}
          closeAlert={state.closeAlert}
          cancleYn={state.cancleYn}
          redYn={state.redYn}
          redButtonLabel={state.redButtonLabel}
          greenButtonLabel={state.greenButtonLabel}
        />
        <Toast />
        <ToastFull />
        <Loading loading={state.loading} />
      </StateContext.Provider>
    </DispatchContext.Provider>
  );
}

export default Context;
